/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b436490ee5f9e6ca662edf275144f5dd>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const IncidentIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 14.25h2m12 0h-2m0 0H3m10 0-1.4-3.5M3 14.25l1.4-3.5m0 0 .1-.25 1.3-3.25m-1.4 3.5h7.2m0 0-.1-.25-1.3-3.25m-4.4 0L5.9 7 8 1.75 10.1 7l.1.25m-4.4 0h4.4"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
IncidentIcon.displayName = 'IncidentIcon';
var _default = exports.default = IncidentIcon;